/**
 * Генерирует случайный ID для бронирования (8 hex-символов)
 * @returns {string} Случайный ID в формате hex строки длиной 8 символов
 */
export const generateRandomCheckoutId = (): string => {
  const randomBytes = new Uint8Array(4)
  crypto.getRandomValues(randomBytes)
  return Array.from(randomBytes)
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}
